import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const SupervisorRoute = () => {
  const { user, isSupervisor } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  if (!isSupervisor()) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-3">
            <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-900">Supervisor Access Required</h3>
          <p className="text-sm text-gray-500 mt-1">You need a supervisor, manager, or admin role.</p>
          <button onClick={() => window.history.back()} className="mt-4 text-blue-600 text-sm font-medium">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default SupervisorRoute;
